import type { CSSProperties } from "react";

/*
  カードの銘柄のロゴ。出どころは aaronfagan/svg-credit-card-payment-icons (Apache-2.0) の flat-rounded。
  色も形も変えずに public/assets/card-brand-*.svg として置いている。
  HP 側 (.hp) と申し込みページ (pay-*) のどちらでも使えるよう、見た目はインライン指定にしている。
*/

export type CardBrand = "visa" | "mastercard" | "amex" | "jcb";

const BRAND_NAME: Record<CardBrand, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  jcb: "JCB",
};

const ALL_BRANDS: CardBrand[] = ["visa", "mastercard", "amex", "jcb"];

/** 券面の比は 780 対 500。高さは字の 1.4 倍 */
const LOGO_STYLE: CSSProperties = { display: "block", height: "1.4em", width: "auto", aspectRatio: "780 / 500", flex: "none" };

/** 銘柄のロゴを横に並べる。brands を渡さなければ4つとも。alt は銘柄の名前 */
export function CardBrandLogos({ brands = ALL_BRANDS, style }: { brands?: CardBrand[]; style?: CSSProperties }) {
  return (
    <span
      className="card-brand-logos"
      style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: "0.4em", verticalAlign: "middle", lineHeight: 1, ...style }}
    >
      {brands.map((b) => (
        <img key={b} src={`/assets/card-brand-${b}.svg`} alt={BRAND_NAME[b]} width={39} height={25} loading="lazy" decoding="async" style={LOGO_STYLE} />
      ))}
    </span>
  );
}
